























































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import { Course } from 'frontend/types';

@Component({
  components: {},
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
  },
})
export default class DetailedDescription extends Vue {
  @Prop({ type: Object, required: true })
  private course!: Course;
}
